export const KLIP_STYLE_SHEET = `:root {
    --animation-duration: 300ms;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  .animated {
    animation-duration: var(--animation-duration);
    animation-fill-mode: both;
  }
  .fadeIn {
    animation-name: fadeIn;
  }
  .fadeOut {
    animation-name: fadeOut;
  }
  #klip-wrapper {
    -webkit-user-select: none;
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    user-select: none;
    width: 100%;
    z-index: 99999999999999;
  }
  .klip-modal__headerLogo {
    height: 21px;
  }
  .klip-modal__header p {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    align-items: center;
    justify-content: center;
    display: flex;
    flex: 1;
  }
  .klip-modal__close__wrapper {
    position: absolute;
    top: 0px;
    right: 5%;
    z-index: 10000;
    border-radius: 26px;
    padding: 6px;
    box-sizing: border-box;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
  .klip-modal__close__icon {
    position: relative;
    top: 7px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(45deg);
  }
  .klip-modal__close__line1 {
    position: absolute;
    width: 100%;
    border: 1px solid var(--font-color-08);
  }
  .klip-modal__close__line2 {
    position: absolute;
    width: 100%;
    border: 1px solid var(--font-color-08);
    transform: rotate(90deg);
  }
  .klip-qrcode__base {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background: rgba(37, 41, 46, 0.95);
    height: 100%;
    left: 0;
    pointer-events: auto;
    position: fixed;
    top: 0;
    transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);
    width: 100%;
    will-change: opacity;
    padding: 40px;
    box-sizing: border-box;
  }
  .klip-qrcode__text {
    color: rgba(60, 66, 82, 0.6);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 1.1875em;
    margin: 10px 0 20px 0;
    text-align: center;
    width: 100%;
  }
  @media only screen and (max-width: 768px) {
    .klip-qrcode__text {
      font-size: 4vw;
    }
  }
  @media only screen and (max-width: 320px) {
    .klip-qrcode__text {
      font-size: 14px;
    }
  }
  .klip-qrcode__image {
    width: calc(100% - 30px);
    box-sizing: border-box;
    cursor: none;
    margin: 0 auto;
  }
  .klip-qrcode__notification {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 16px;
    padding: 16px 20px;
    border-radius: 16px;
    text-align: center;
    transition: all 0.1s ease-in-out;
    background: white;
    color: black;
    margin-bottom: -60px;
    opacity: 0;
  }
  .klip-qrcode__notification.notification__show {
    opacity: 1;
  }
  @media only screen and (max-width: 768px) {
    .klip-modal__header {
      height: 130px;
    }
    .klip-modal__base {
      overflow: auto;
    }
  }
  @media only screen and (min-device-width: 415px) and (max-width: 768px) {
    #content {
      max-width: 768px;
      box-sizing: border-box;
    }
  }
  @media only screen and (min-width: 375px) and (max-width: 415px) {
    #content {
      max-width: 414px;
      box-sizing: border-box;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 375px) {
    #content {
      max-width: 375px;
      box-sizing: border-box;
    }
  }
  @media only screen and (max-width: 320px) {
    #content {
      max-width: 320px;
      box-sizing: border-box;
    }
  }
  .klip-modal__base {
    -webkit-font-smoothing: antialiased;
    background: var(--background-modal);
    border-radius: 24px;
    box-shadow: 0 10px 50px 5px rgba(0, 0, 0, 0.4);
    font-family: ui-rounded, "SF Pro Rounded", "SF Pro Text", medium-content-sans-serif-font,
      -apple-system, BlinkMacSystemFont, ui-sans-serif, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell,
      "Open Sans", "Helvetica Neue", sans-serif;
    margin-top: 41px;
    padding: 24px 24px 22px;
    pointer-events: auto;
    position: relative;
    text-align: center;
    transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);
    will-change: transform;
    overflow: visible;
    transform: translateY(-50%);
    top: 50%;
    max-width: 500px;
    margin: auto;
  }
  @media only screen and (max-width: 320px) {
    .klip-modal__base {
      padding: 24px 12px;
    }
  }
  .klip-modal__base .hidden {
    transform: translateY(150%);
    transition: 0.125s cubic-bezier(0.4, 0, 1, 1);
  }
  .klip-modal__header {
    align-items: center;
    display: flex;
    height: 26px;
    left: 0;
    justify-content: space-between;
    position: absolute;
    top: 23px;
    width: 100%;
  }
  .klip-modal__base .wc-logo {
    align-items: center;
    display: flex;
    height: 26px;
    margin-top: 15px;
    padding-bottom: 15px;
    pointer-events: auto;
  }
  .klip-modal__base .wc-logo div {
    background-color: #3399ff;
    height: 21px;
    margin-right: 5px;
    mask-image: url("images/wc-logo.svg") center no-repeat;
    width: 32px;
  }
  .klip-modal__base .wc-logo p {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    margin: 0;
  }
  .klip-modal__base h2 {
    color: rgba(60, 66, 82, 0.6);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 1.1875em;
    margin: 0 0 19px 0;
    text-align: center;
    width: 100%;
  }
  .klip-modal__base__row {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    align-items: center;
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    height: 56px;
    justify-content: space-between;
    padding: 0 15px;
    position: relative;
    margin: 0px 0px 8px;
    text-align: left;
    transition: 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    will-change: transform;
    text-decoration: none;
  }
  .klip-modal__base__row:hover {
    background: rgba(60, 66, 82, 0.06);
  }
  .klip-modal__base__row:active {
    background: rgba(60, 66, 82, 0.06);
    transform: scale(0.975);
    transition: 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .klip-modal__base__row__h3 {
    color: #25292e;
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    padding-bottom: 3px;
  }
  .klip-modal__base__row__right {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .klip-modal__base__row__right__app-icon {
    border-radius: 8px;
    height: 34px;
    margin: 0 11px 2px 0;
    width: 34px;
    background-size: 100%;
    box-shadow: 0 4px 12px 0 rgba(37, 41, 46, 0.25);
  }
  .klip-modal__base__row__right__caret {
    height: 18px;
    opacity: 0.3;
    transition: 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    width: 8px;
    will-change: opacity;
  }
  .klip-modal__base__row:hover .caret,
  .klip-modal__base__row:active .caret {
    opacity: 0.6;
  }
  .klip-modal__mobile__toggle {
    width: 80%;
    display: flex;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    margin-bottom: 18px;
    background: #d4d5d9;
  }
  .klip-modal__single_wallet {
    // display: flex;
    // flex-direction: column;
    // justify-content: flex-start;
    // align-items: flex-start;
    margin-top: 7px;
    margin-bottom: 18px;
  }
  .klip-modal__single_wallet a {
    cursor: pointer;
    color: rgb(64, 153, 255);
    font-size: 21px;
    font-weight: 800;
    text-decoration: none !important;
    margin: 0 auto;
  }
  .klip-modal__otp_wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    margin: 15px 0;
  }
  .klip-modal__description {
    font-size: 14px;
  }
  .klip-modal__input {
    border: none;
    background: #e8e9ed;
    border-style: none;
    padding: 8px 16px;
    outline: none;
    font-style: normal;
    font-stretch: normal;
    font-size: 16px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    border-radius: 8px;
    // width: calc(100% - 16px);
  }
  .klip-modal__button {
    background-color: rgb(64, 153, 255);
    padding: 12px 30px;
    border-radius: 8px;
    text-decoration: none;
    color: rgb(255, 255, 255);
    font-weight: 500;
    margin-top: 10px;
  }
  .klip-modal__mobile__toggle_selector {
    width: calc(50% - 8px);
    background: white;
    position: absolute;
    border-radius: 5px;
    height: calc(100% - 8px);
    top: 4px;
    transition: all 0.2s ease-in-out;
    transform: translate3d(4px, 0, 0);
  }
  .klip-modal__mobile__toggle.right__selected .klip-modal__mobile__toggle_selector {
    transform: translate3d(calc(100% + 12px), 0, 0);
  }
  .klip-modal__mobile__toggle a {
    font-size: 12px;
    width: 50%;
    text-align: center;
    padding: 8px;
    margin: 0;
    font-weight: 600;
    z-index: 1;
  }
  .klip-modal__footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  @media only screen and (max-width: 768px) {
    .klip-modal__footer {
      margin-top: 5vw;
    }
  }
  .klip-modal__footer a {
    cursor: pointer;
    color: #898d97;
    font-size: 15px;
    margin: 0 auto;
  }
  @media only screen and (max-width: 320px) {
    .klip-modal__footer a {
      font-size: 14px;
    }
  }
  .klip-connect__buttons__wrapper {
    max-height: 44vh;
  }
  .klip-connect__buttons__wrapper__android {
    margin: 50% 0;
  }
  .klip-connect__buttons__wrapper__wrap {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    margin: 10px 0;
  }
  @media only screen and (min-width: 768px) {
    .klip-connect__buttons__wrapper__wrap {
      margin-top: 40px;
    }
  }
  .klip-connect__button {
    background-color: rgb(64, 153, 255);
    padding: 12px;
    border-radius: 8px;
    text-decoration: none;
    color: rgb(255, 255, 255);
    font-weight: 500;
  }
  .klip-connect__button__icon_anchor {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 8px;
    width: 42px;
    justify-self: center;
    flex-direction: column;
    text-decoration: none !important;
  }
  @media only screen and (max-width: 320px) {
    .klip-connect__button__icon_anchor {
      margin: 4px;
    }
  }
  .klip-connect__button__icon {
    border-radius: 10px;
    height: 42px;
    margin: 0;
    width: 42px;
    background-size: cover !important;
    box-shadow: 0 4px 12px 0 rgba(37, 41, 46, 0.25);
  }
  .klip-connect__button__text {
    color: #424952;
    font-size: 2.7vw;
    text-decoration: none !important;
    padding: 0;
    margin-top: 1.8vw;
    font-weight: 600;
  }
  @media only screen and (min-width: 768px) {
    .klip-connect__button__text {
      font-size: 16px;
      margin-top: 12px;
    }
  }
  .klip-search__input {
    border: none;
    background: #d4d5d9;
    border-style: none;
    padding: 8px 16px;
    outline: none;
    font-style: normal;
    font-stretch: normal;
    font-size: 16px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    border-radius: 8px;
    width: calc(100% - 16px);
    margin: 0;
    margin-bottom: 8px;
  }
  `;
